import { motion } from "framer-motion"
import { cn } from "@/lib/utils"

interface PrincipleCardProps {
  title: string
  description: string
  className?: string
  variant?: "default" | "purple"
}

const gradientVariants = {
  default: "bg-gradient-floral",
  purple: "bg-gradient-thistle"
} as const;

const motionVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
  hover: { 
    scale: 1.02,
    transition: { duration: 0.2 }
  }
};

export function PrincipleCard({ 
  title, 
  description, 
  className,
  variant = "default" 
}: PrincipleCardProps) {
  return (
    <motion.div
      variants={motionVariants}
      whileHover="hover"
      className={cn(
        "p-10 rounded-xl",
        gradientVariants[variant],
        "border border-gray-200",
        "hover:shadow-neumorphic transition-all duration-300",
        "flex flex-col items-center",
        className
      )}
    >
      <h3 className="text-h3 mb-6 text-center whitespace-pre-line">
        {title}
      </h3>
      <p className="text-body text-center max-w-[280px]">
        {description}
      </p>
    </motion.div>
  )
} 